import { create } from 'zustand';

const decodePromo = (encoded) => {
	if (!encoded) return null;

	const safe = decodeURIComponent(encoded);

	const jsonStr = atob(safe);

	return JSON.parse(jsonStr);
};

export const usePromoStore = create((set) => ({
	promo: null,
	promoError: null,

	setPromo: (promo) => set({ promo, promoError: null }),
	clearPromo: () => set({ promo: null, promoError: null }),

	loadPromoFromUrl: () => {
		try {
			const params = new URLSearchParams(window.location.search);
			const p = params.get('p');

			if (!p) {
				set({ promo: null, promoError: null });

				return;
			}

			const promo = decodePromo(p);

			set({ promo, promoError: null });
		} catch (e) {
			set({ promo: null, promoError: 'invalid_promo_param' });
		}
	},
}));
